import View from './LimitOfUse';
import enhancer from './LimitOfUse.enhancer';

const LimitOfUse = enhancer(View);

export default LimitOfUse;
